import React, { FC } from 'react';

import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useEvent } from 'components/context/EventContext';

import useStyles from './style';

const Location: FC = () => {
  const classes = useStyles();

  const { event } = useEvent();

  const location = event?.location;

  const openGoogleMaps = () =>
    location?.lat &&
    location.lng &&
    window.open(
      `https://www.google.com/maps/@${location.lat},${location.lng},13z`,
      '_blank',
      'noreferrer'
    );

  return !!location?.name ? (
    <div className={classes.location} onClick={openGoogleMaps} role="link">
      <Icon icon={IconmoonFont['location-16']} />
      <span className="name">{location.name}</span>
    </div>
  ) : null;
};

export default Location;
